import { AuthenticationHandler } from "./authentication-handler";

interface QueryParameters
{
    [key: string]: string | number | boolean | null | undefined;
}

export class Requester
{
    static get(url: string, parameters?: QueryParameters): Promise<any>
    {
        return Requester.sendRequest("GET", Requester.getUrl(url, parameters));
    }

    static post(url: string, data: unknown): Promise<any>
    {
        return Requester.sendRequest("POST", Requester.getUrl(url), JSON.stringify(data));
    }

    static getUrl(path: string, parameters?: QueryParameters): string
    {
        const [base, existingQuery] = path.split("?");
        return (base.startsWith("api/") ? "" : "api/") + base + "?" + Requester.buildQueryString(existingQuery, parameters);
    }

    private static async sendRequest(method: string, url: string, body?: string): Promise<any>
    {
        const headers: Record<string, string> = {};
        const controlToken = localStorage[AuthenticationHandler.controlTokenParamName];
        if (controlToken)
        {
            headers[AuthenticationHandler.controlTokenParamName] = controlToken;
        }
        if (method === "POST")
        {
            headers["Content-Type"] = "application/json; charset=utf-8";
        }

        let response: Response;
        try
        {
            response = await fetch(url, {
                method: method,
                headers: headers,
                body: body,
                credentials: "same-origin",
            });
        }
        catch (e)
        {
            return Promise.reject({ status: 0, responseText: "" });
        }

        const responseText = await response.text();
        if (!response.ok)
        {
            return Promise.reject({ status: response.status, responseText: responseText });
        }

        return responseText === "" ? null : JSON.parse(responseText);
    }

    private static buildQueryString(existingQuery: string, parameters?: QueryParameters): string
    {
        const search = new URLSearchParams();
        const params = parameters ?? {};
        for (const key of Object.keys(params))
        {
            const value = params[key];
            search.set(key, value === undefined || value === null ? "" : String(value));
        }
        if (existingQuery)
        {
            new URLSearchParams(existingQuery).forEach((value, key) =>
            {
                if (!search.get(key))
                {
                    search.set(key, value);
                }
            });
        }
        return search.toString();
    }
}
